// extracted by mini-css-extract-plugin
export var chevron = "_aw-2";
export var dropdownItems = "_aw-0";
export var item = "_aw-1";